import { render, staticRenderFns } from "./employee-managment.vue?vue&type=template&id=fbe894dc&scoped=true&"
import script from "./employee-managment.vue?vue&type=script&lang=js&"
export * from "./employee-managment.vue?vue&type=script&lang=js&"
import style0 from "./employee-managment.vue?vue&type=style&index=0&id=fbe894dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe894dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCombobox,VIcon,VRow,VSimpleTable,VSpacer})
